/**
 * Decode a JWT payload without an external library.
 * Works in the browser using `atob`.
 */
function decodeJwtPayload(token: string): Record<string, unknown> {
	const parts = token.split(".");
	if (parts.length !== 3) throw new Error("Invalid JWT format");
	// Handle URL-safe Base64
	const base64 = parts[1].replace(/-/g, "+").replace(/_/g, "/");
	return JSON.parse(atob(base64));
}

/**
 * Extract the original filename from a JUDO binary download token (JWT).
 *
 * Can be used outside of React components (e.g. in utility functions).
 * For use inside components, prefer the `extractFileNameFromToken` from {@link useFileHandling}.
 *
 * @param token  JWT download token (or null/undefined)
 * @param fallbackText  Value returned when the token is absent or decoding fails
 * @returns The decoded filename, or `fallbackText`
 */
export function extractFileNameFromToken(token?: string | null, fallbackText?: string): string {
	if (!token) return fallbackText ?? "";
	try {
		const payload = decodeJwtPayload(token) as { fileName?: string };
		return payload.fileName ?? fallbackText ?? "";
	} catch {
		console.error(`Decoding of JWT token failed for: ${token}`);
		return fallbackText ?? "";
	}
}
